import { getOuterUrl } from './get-outer-url';
import { urijs } from '../urijs';
export var numberToPage = function (page, containsTrailingSlash) {
    if (containsTrailingSlash === void 0) { containsTrailingSlash = false; }
    return "" + (page > 1 ? "/page/" + page : '') + (containsTrailingSlash ? '/' : '');
};
export var createPageUrl = function (page, sectionUrl) {
    var containsTrailingSlash = new urijs(sectionUrl || '').pathname().endsWith('/');
    return getOuterUrl(numberToPage(page, containsTrailingSlash), sectionUrl);
};
